import { useCallback, useState } from "react";
import { useReportApi, unwrapReport } from "../api/reportApi";

// #918 — Score Admin's "was this rider actually emailed their score sheet"
// indicator. Calls report-api's authed, read-only
// GET /score-sheets/rides/:rideId/status — never creates a sheet-request row
// and never sends anything, unlike useResendScoreSheet/useScorePageLink.
// `sheetEmailedAt` is the field that reflects a CONFIRMED send (null if the
// rider was never actually emailed, even mid-render) — see report-api's
// sheet-request.js markSheetEmailed doc comment for why that's distinct from
// "a request row exists" or "status is READY".
export function useScoreSheetStatus() {
  const reportApi = useReportApi();
  const [loading, setLoading] = useState(false);

  const fetchStatus = useCallback(
    async (rideId) => {
      setLoading(true);
      try {
        const res = await reportApi.riderSheets.getScoreSheetStatus(rideId);
        return unwrapReport(res);
      } finally {
        setLoading(false);
      }
    },
    [reportApi],
  );

  return { fetchStatus, loading };
}

export default useScoreSheetStatus;
